var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruckLeftUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 363,
    viewBox: "0 0 435 363",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M312.41 362.452L410.438 306.391L98.0066 128.4L0 184.439L312.41 362.452Z",
    fill: "#EFECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.34 0.576145L176.922 39.3262L90.3 88.8425L22.7187 50.0924L109.34 0.576145Z",
    fill: "url(#paint0_linear_2205_2999)",
    stroke: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8022 176.146L44.3578 172.543L58.3836 162.95L68.6315 155.701V150.21L46.0731 138.035L34.8047 135.777V141.225",
    fill: "#000508"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7231 161.431L61.5535 153.444C62.2482 152.902 63.0081 152.468 63.7898 152.142H63.8115C66.9162 150.862 70.7158 151.209 74.8193 153.488C85.306 159.326 93.817 175.56 93.817 189.755C93.817 197.807 91.0814 203.471 86.8041 205.815H86.8259L70.4987 215.169L70.7809 211.719L73.864 204.795C73.864 204.795 73.9725 204.687 74.1462 204.513C63.9417 198.393 55.7999 182.527 55.7999 168.615C55.7999 167.096 55.9084 165.642 56.0821 164.296H53.8241L47.6797 161.41L47.7231 161.431Z",
    fill: "#000F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7998 89.8173L177.428 40.1898V157.148L90.7998 206.754V89.8173Z",
    fill: "#222222",
    stroke: "url(#paint1_linear_2205_2999)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4109 182.537C76.4252 189.95 77.4256 197.337 76.6293 203.276C75.8308 209.231 73.2496 213.62 69.2107 215.262C65.1717 216.903 60.259 215.558 55.5309 211.849C50.8155 208.149 46.3766 202.159 43.3623 194.746C40.3481 187.333 39.3477 179.946 40.144 174.007C40.9424 168.052 43.5236 163.663 47.5626 162.022C51.6015 160.381 56.5142 161.725 61.2424 165.435C65.9577 169.134 70.3966 175.124 73.4109 182.537Z",
    fill: "#222222",
    stroke: "url(#paint2_linear_2205_2999)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.248 181.355C45.248 191.165 51.1319 202.386 58.3619 206.401C65.6136 210.438 71.4758 205.75 71.4758 195.94C71.4758 186.13 65.5919 174.909 58.3619 170.894C51.1102 166.857 45.248 171.545 45.248 181.355Z",
    fill: "url(#paint3_linear_2205_2999)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7231 182.722C47.7231 190.687 52.4997 199.803 58.3836 203.08C64.2675 206.357 69.044 202.537 69.044 194.572C69.044 186.607 64.2675 177.492 58.3836 174.214C52.4997 170.937 47.7231 174.757 47.7231 182.722Z",
    fill: "#000F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2646 183.59C49.2646 190.405 53.3464 198.175 58.3836 200.975C63.4207 203.775 67.5025 200.519 67.5025 193.704C67.5025 186.889 63.4207 179.119 58.3836 176.32C53.3464 173.52 49.2646 176.775 49.2646 183.59Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0222 200.042C66.6213 198.58 67.4637 192.29 64.9035 185.994C62.3434 179.698 57.3503 175.779 53.7512 177.242C50.1521 178.704 49.3098 184.994 51.8699 191.29C54.43 197.586 59.4231 201.504 63.0222 200.042Z",
    fill: "#222222"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3077 193.367C61.7963 192.762 62.1428 190.156 61.0817 187.546C60.0206 184.937 57.9538 183.312 56.4652 183.917C54.9767 184.521 54.6302 187.127 55.6913 189.737C56.7523 192.346 58.8192 193.971 60.3077 193.367Z",
    fill: "#D7F0FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2583 187.411C54.2583 189.755 55.6696 192.446 57.4065 193.401C59.1434 194.356 60.5547 193.249 60.5547 190.905C60.5547 188.561 59.1434 185.87 57.4065 184.915C55.6696 183.96 54.2583 185.067 54.2583 187.411Z",
    fill: "url(#paint4_linear_2205_2999)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8266 179.662C51.6963 179.597 51.5878 179.51 51.4575 179.402C51.9569 178.512 52.6082 177.839 53.3899 177.427C53.455 177.709 53.4984 178.013 53.4984 178.295C53.4984 179.554 52.7385 180.161 51.8049 179.641L51.8266 179.662Z",
    fill: "url(#paint5_linear_2205_2999)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4343 191.295C53.3679 191.816 54.1278 193.27 54.1278 194.529C54.1278 194.811 54.0844 195.071 54.0193 195.267C53.1508 194.008 52.3909 192.597 51.8047 191.1C52.0001 191.1 52.2172 191.165 52.456 191.273L52.4343 191.295Z",
    fill: "url(#paint6_linear_2205_2999)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3835 177.839C58.9263 178.143 59.4691 178.512 59.9902 178.946C59.7731 179.749 59.1434 180.074 58.3835 179.662C57.6236 179.25 56.994 178.208 56.7769 177.166C57.2979 177.318 57.8407 177.535 58.3835 177.839Z",
    fill: "url(#paint7_linear_2205_2999)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8265 184.241C51.8265 185.348 51.2403 185.956 50.4804 185.738C50.437 185.239 50.3936 184.718 50.3936 184.219C50.3936 183.199 50.5021 182.288 50.6975 181.463C51.3489 182.136 51.8265 183.243 51.8265 184.241Z",
    fill: "url(#paint8_linear_2205_2999)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8995 200.085C62.7475 199.673 62.6606 199.217 62.6606 198.805C62.6606 197.546 63.4206 196.938 64.3542 197.459C64.6364 197.611 64.9187 197.871 65.1358 198.175C64.5496 199.109 63.7897 199.76 62.8778 200.107L62.8995 200.085Z",
    fill: "url(#paint9_linear_2205_2999)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3835 197.459C59.1868 197.915 59.8599 199.043 60.0336 200.172C59.4908 200.02 58.948 199.803 58.3835 199.477C57.819 199.152 57.2545 198.783 56.7334 198.327C56.9071 197.394 57.5802 197.003 58.3835 197.459Z",
    fill: "url(#paint10_linear_2205_2999)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9619 192.033C64.9619 190.991 65.4613 190.427 66.1561 190.514C66.2863 191.382 66.3732 192.25 66.3732 193.096C66.3732 193.747 66.3298 194.377 66.2429 194.963C65.5047 194.312 64.9619 193.096 64.9619 192.033Z",
    fill: "url(#paint11_linear_2205_2999)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3542 186.238C63.4206 185.717 62.6606 184.263 62.6606 183.004C62.6606 182.657 62.7258 182.374 62.8126 182.136C63.7028 183.438 64.4627 184.892 65.0489 186.433C64.8318 186.433 64.593 186.39 64.3542 186.259V186.238Z",
    fill: "url(#paint12_linear_2205_2999)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2053 88.6161L21.6908 49.8535L90.2997 89.5276V207.617L83.656 203.797V181.638L75.297 159.76L55.3222 148.995L51.6746 150.384C42.7294 153.814 36.8021 162.408 36.8021 171.979V176.168L6.73145 159.109V112.62C6.73145 104.503 7.90388 96.4076 10.2053 88.6161Z",
    fill: "#D0E1EE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M58.188 133.065L73.104 141.182C79.3786 145.74 83.4387 144.264 83.4387 137.427V94.4323L32.959 65.2627L23.5796 92.9998L23.6664 136.429L38.8863 144.047C44.5531 134.237 58.188 133.086 58.188 133.086V133.065Z",
    fill: "#B1C8DA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08594 113.466L3.73476 115.159V76.8738L1.08594 75.1592V113.466Z",
    fill: "url(#paint13_linear_2205_2999)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73476 76.8523L18.6073 68.5182L15.9584 66.9121L1.08594 75.2463L3.73476 76.8523Z",
    fill: "url(#paint14_linear_2205_2999)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73438 115.159L18.6069 106.825V68.5186L3.73438 76.8527V115.159Z",
    fill: "#001208"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3136 114.899C10.4439 114.899 10.5958 114.856 10.7261 114.791L21.9076 108.236C22.2984 108.019 22.4504 107.498 22.2333 107.108C22.0162 106.717 21.4951 106.565 21.1043 106.782L11.1603 112.642V110.189C11.1603 109.734 10.7912 109.365 10.3353 109.365C9.87935 109.365 9.51025 109.734 9.51025 110.189V114.074C9.51025 114.378 9.66224 114.639 9.92278 114.791C10.053 114.856 10.205 114.899 10.3353 114.899H10.3136Z",
    fill: "#001208"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3136 72.707C10.7695 72.707 11.1386 72.338 11.1386 71.8822V67.9756L22.5589 61.573C22.9498 61.356 23.1017 60.8351 22.8846 60.4444C22.6675 60.0538 22.1464 59.9019 21.7556 60.1189L9.90103 66.7602C9.64049 66.9121 9.4668 67.1942 9.4668 67.4764V71.8822C9.4668 72.338 9.8359 72.707 10.2918 72.707H10.3136Z",
    fill: "#001208"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3282 174.54L29.8761 176.385L3.86547 157.481L0.391602 138.404L6.73142 134.193V138.209L33.3282 153.596V174.54Z",
    fill: "url(#paint15_linear_2205_2999)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8761 176.386L0.391602 159.348V138.404L29.8761 155.442V176.386Z",
    fill: "#222222"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4829 20.3728L115.516 34.8708V32.9609L90.4829 14.0137V20.3728Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M115.516 32.939L124.31 27.8604L99.2544 9L90.4829 14.0786L115.516 32.939Z",
    fill: "#222222"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M115.517 34.8706L124.31 29.792V27.8604L115.517 32.939V34.8706Z",
    fill: "#222222"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4263 33.3953L91.4816 47.8932V45.9833L66.4263 27.0361V33.3953Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4818 45.9615L100.275 40.8829L75.2198 22.0225L66.4482 27.1011L91.4818 45.9615Z",
    fill: "#222222"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4814 47.8931L100.275 42.8144V40.8828L91.4814 45.9614V47.8931Z",
    fill: "#222222"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3916 46.4167L67.4469 60.9147V59.0048L42.3916 40.0576V46.4167Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4472 58.983L76.2404 53.9043L51.1851 35.0439L42.4136 40.1226L67.4472 58.983Z",
    fill: "#222222"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4468 60.9145L76.24 55.8359V53.9043L67.4468 58.9829V60.9145Z",
    fill: "#222222"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M150.982 197.113V201.02L187.198 180.315V176.386L207.911 164.536L211.015 166.533L207.911 181.899L133.374 228.301L130.27 226.326V208.963L150.982 197.113Z",
    fill: "#000F20"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M154.087 199.089V203.017L190.303 182.29V178.383L211.016 166.533V183.896L133.375 228.301V210.939L154.087 199.089Z",
    fill: "#222222"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4907 193.489C93.4907 188.548 96.1258 183.975 100.399 181.466H100.419L100.534 181.4L113.009 174.271L160.523 201.354L146.689 220.718L146.65 220.774L146.627 220.837L140.946 236.363L93.4481 209.216L93.4907 193.49V193.489Z",
    fill: "#222222",
    stroke: "url(#paint16_linear_2205_2999)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M151.317 207.466L151.318 207.466L160.774 202.055V225.32L141.734 236.207V223.982C141.734 217.151 145.394 210.849 151.317 207.466Z",
    fill: "#222222",
    stroke: "url(#paint17_linear_2205_2999)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M187.871 242.3C187.871 242.3 180.054 245.534 179.75 257.298L185.07 254.498L192.886 248.247L198.423 244.927L200.876 241.693C198.075 237.005 187.871 242.3 187.871 242.3Z",
    fill: "url(#paint18_linear_2205_2999)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M190.215 244.557L204.046 236.57C204.74 236.028 205.5 235.594 206.282 235.268H206.304C209.408 233.988 213.208 234.335 217.311 236.614C227.798 242.452 236.309 258.686 236.309 272.881C236.309 280.933 233.574 286.597 229.296 288.941H229.318L212.991 298.295L213.273 294.845L216.356 287.921C216.356 287.921 216.465 287.813 216.638 287.639C206.434 281.519 198.292 265.653 198.292 251.741C198.292 250.222 198.401 248.768 198.574 247.422H196.316L190.172 244.536L190.215 244.557Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M181.878 261.226C181.878 275.42 190.389 291.676 200.876 297.493C211.363 303.331 219.874 296.538 219.874 282.344C219.874 268.149 211.363 251.893 200.876 246.077C190.389 240.239 181.878 247.032 181.878 261.226Z",
    fill: "#222222"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M187.74 264.481C187.74 274.291 193.624 285.512 200.854 289.527C208.106 293.564 213.968 288.876 213.968 279.066C213.968 269.256 208.084 258.035 200.854 254.02C193.602 249.983 187.74 254.671 187.74 264.481Z",
    fill: "url(#paint19_linear_2205_2999)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M190.194 265.849C190.194 273.814 194.97 282.93 200.854 286.207C206.738 289.484 211.515 285.664 211.515 277.699C211.515 269.734 206.738 260.618 200.854 257.341C194.97 254.064 190.194 257.884 190.194 265.849Z",
    fill: "#000F20"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M191.757 266.716C191.757 273.531 195.839 281.301 200.876 284.101C205.913 286.901 209.995 283.645 209.995 276.83C209.995 270.015 205.913 262.245 200.876 259.446C195.839 256.646 191.757 259.901 191.757 266.716Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M192.886 267.346C192.886 273.315 196.469 280.152 200.876 282.604C205.284 285.057 208.866 282.213 208.866 276.223C208.866 270.233 205.284 263.418 200.876 260.966C196.469 258.513 192.886 261.356 192.886 267.346Z",
    fill: "#222222"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M197.554 269.95C197.554 272.424 199.031 275.246 200.854 276.266C202.678 277.286 204.155 276.092 204.155 273.618C204.155 271.144 202.678 268.322 200.854 267.302C199.031 266.282 197.554 267.476 197.554 269.95Z",
    fill: "#D7F0FF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M196.751 270.537C196.751 272.881 198.162 275.572 199.899 276.527C201.636 277.482 203.047 276.375 203.047 274.031C203.047 271.687 201.636 268.996 199.899 268.041C198.162 267.086 196.751 268.193 196.751 270.537Z",
    fill: "url(#paint20_linear_2205_2999)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M194.319 262.788C194.189 262.723 194.08 262.636 193.95 262.528C194.45 261.638 195.101 260.965 195.883 260.553C195.948 260.835 195.991 261.139 195.991 261.421C195.991 262.68 195.231 263.287 194.298 262.767L194.319 262.788Z",
    fill: "url(#paint21_linear_2205_2999)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M194.927 274.421C195.861 274.942 196.621 276.396 196.621 277.655C196.621 277.937 196.577 278.197 196.512 278.393C195.643 277.134 194.884 275.723 194.297 274.226C194.493 274.226 194.71 274.291 194.949 274.399L194.927 274.421Z",
    fill: "url(#paint22_linear_2205_2999)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M200.876 260.965C201.419 261.269 201.962 261.638 202.483 262.072C202.266 262.875 201.636 263.2 200.876 262.788C200.116 262.376 199.487 261.334 199.27 260.292C199.791 260.444 200.333 260.661 200.876 260.965Z",
    fill: "url(#paint23_linear_2205_2999)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M194.319 267.345C194.319 268.452 193.733 269.06 192.973 268.843C192.93 268.344 192.886 267.823 192.886 267.324C192.886 266.304 192.995 265.392 193.19 264.567C193.842 265.24 194.319 266.347 194.319 267.345Z",
    fill: "url(#paint24_linear_2205_2999)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M205.392 283.211C205.24 282.799 205.153 282.343 205.153 281.931C205.153 280.672 205.913 280.064 206.847 280.585C207.129 280.737 207.411 280.997 207.628 281.301C207.042 282.235 206.282 282.886 205.37 283.233L205.392 283.211Z",
    fill: "url(#paint25_linear_2205_2999)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M200.876 280.564C201.679 281.019 202.353 282.148 202.526 283.276C201.983 283.125 201.441 282.908 200.876 282.582C200.312 282.256 199.747 281.887 199.226 281.432C199.4 280.498 200.073 280.108 200.876 280.564Z",
    fill: "url(#paint26_linear_2205_2999)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M207.455 275.159C207.455 274.117 207.954 273.553 208.649 273.64C208.779 274.508 208.866 275.376 208.866 276.222C208.866 276.873 208.822 277.503 208.736 278.089C207.997 277.438 207.455 276.222 207.455 275.159Z",
    fill: "url(#paint27_linear_2205_2999)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M206.847 269.364C205.913 268.843 205.153 267.389 205.153 266.13C205.153 265.783 205.218 265.5 205.305 265.262C206.195 266.564 206.955 268.018 207.542 269.559C207.325 269.559 207.086 269.516 206.847 269.385V269.364Z",
    fill: "url(#paint28_linear_2205_2999)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M240.575 273.727L240.851 273.602L240.869 273.299C241.1 269.231 240.51 265.999 239.859 263.779C239.533 262.668 239.191 261.811 238.93 261.227C238.799 260.935 238.688 260.712 238.608 260.56C238.568 260.484 238.537 260.426 238.514 260.385C238.503 260.365 238.494 260.35 238.488 260.339L238.48 260.326L238.478 260.322L238.477 260.32L238.477 260.32C238.477 260.32 238.476 260.319 238.046 260.574L238.476 260.319L238.409 260.206L238.295 260.14L198.367 237.308L198.146 237.182L197.915 237.286L187.667 241.865L188.063 242.783C190.807 241.636 193.71 241.63 195.951 241.922C197.067 242.068 198.01 242.286 198.672 242.468C199.003 242.559 199.263 242.64 199.438 242.698C199.526 242.727 199.593 242.751 199.637 242.766C199.66 242.774 199.676 242.78 199.686 242.784L199.698 242.788L199.7 242.789L199.7 242.789L199.7 242.789L199.7 242.789L199.7 242.789C210.725 246.957 216.377 256.514 219.275 265.11C220.722 269.403 221.475 273.436 221.865 276.396C222.06 277.876 222.165 279.086 222.221 279.924C222.249 280.344 222.264 280.67 222.273 280.89C222.277 281.001 222.28 281.085 222.281 281.14L222.283 281.203L222.283 281.218L222.283 281.221L222.283 281.222L222.294 281.984L222.989 281.67L240.575 273.727Z",
    fill: "#222222",
    stroke: "url(#paint29_linear_2205_2999)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M235.419 269.77C235.419 269.77 227.603 273.004 227.299 284.767L232.618 281.968L240.434 275.717L245.971 272.396L248.424 269.162C245.623 264.474 235.419 269.77 235.419 269.77Z",
    fill: "url(#paint30_linear_2205_2999)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M237.764 272.027L251.594 264.04C252.289 263.498 253.049 263.064 253.831 262.738H253.852C256.957 261.457 260.757 261.805 264.86 264.084C275.347 269.922 283.858 286.156 283.858 300.35C283.858 308.402 281.122 314.067 276.845 316.411H276.867L260.54 325.765L260.822 322.314L263.905 315.391C263.905 315.391 264.014 315.282 264.187 315.109C253.983 308.988 245.841 293.123 245.841 279.211C245.841 277.692 245.949 276.238 246.123 274.892H243.865L237.721 272.005L237.764 272.027Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M259.44 326.32C267.994 322.845 269.997 307.902 263.915 292.945C257.833 277.987 245.969 268.679 237.415 272.154C228.862 275.63 226.858 290.573 232.94 305.53C239.022 320.488 250.886 329.796 259.44 326.32Z",
    fill: "#222222"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M235.289 291.951C235.289 301.761 241.173 312.982 248.403 316.997C255.655 321.034 261.517 316.346 261.517 306.536C261.517 296.726 255.633 285.505 248.403 281.49C241.151 277.453 235.289 282.141 235.289 291.951Z",
    fill: "url(#paint31_linear_2205_2999)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M237.742 293.318C237.742 301.283 242.519 310.399 248.403 313.676C254.287 316.953 259.063 313.133 259.063 305.168C259.063 297.203 254.287 288.087 248.403 284.81C242.519 281.533 237.742 285.353 237.742 293.318Z",
    fill: "#000F20"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M239.306 294.186C239.306 301.001 243.387 308.771 248.425 311.571C253.462 314.37 257.543 311.115 257.543 304.3C257.543 297.485 253.462 289.715 248.425 286.915C243.387 284.116 239.306 287.371 239.306 294.186Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M253.063 310.638C256.662 309.175 257.505 302.886 254.945 296.59C252.384 290.294 247.391 286.375 243.792 287.837C240.193 289.3 239.351 295.589 241.911 301.885C244.471 308.182 249.464 312.1 253.063 310.638Z",
    fill: "#222222"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M250.327 303.963C251.816 303.358 252.162 300.753 251.101 298.143C250.04 295.534 247.973 293.908 246.485 294.513C244.996 295.118 244.65 297.724 245.711 300.333C246.772 302.943 248.839 304.568 250.327 303.963Z",
    fill: "#D7F0FF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M244.299 298.007C244.299 300.351 245.711 303.042 247.448 303.997C249.184 304.952 250.596 303.845 250.596 301.501C250.596 299.157 249.184 296.466 247.448 295.511C245.711 294.556 244.299 295.663 244.299 298.007Z",
    fill: "url(#paint32_linear_2205_2999)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M241.846 290.258C241.716 290.193 241.607 290.106 241.477 289.997C241.976 289.108 242.628 288.435 243.409 288.022C243.475 288.305 243.518 288.608 243.518 288.891C243.518 290.149 242.758 290.757 241.824 290.236L241.846 290.258Z",
    fill: "url(#paint33_linear_2205_2999)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M242.476 301.891C243.409 302.412 244.169 303.866 244.169 305.125C244.169 305.407 244.126 305.667 244.061 305.862C243.192 304.604 242.432 303.193 241.846 301.695C242.042 301.695 242.259 301.76 242.498 301.869L242.476 301.891Z",
    fill: "url(#paint34_linear_2205_2999)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M248.403 288.435C248.946 288.738 249.489 289.107 250.01 289.541C249.793 290.344 249.163 290.67 248.403 290.258C247.643 289.845 247.014 288.803 246.796 287.762C247.317 287.914 247.86 288.131 248.403 288.435Z",
    fill: "url(#paint35_linear_2205_2999)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M241.846 294.815C241.846 295.922 241.26 296.53 240.5 296.313C240.457 295.814 240.413 295.293 240.413 294.793C240.413 293.773 240.522 292.862 240.717 292.037C241.368 292.71 241.846 293.817 241.846 294.815Z",
    fill: "url(#paint36_linear_2205_2999)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M252.919 310.681C252.767 310.269 252.68 309.813 252.68 309.4C252.68 308.142 253.44 307.534 254.374 308.055C254.656 308.207 254.938 308.467 255.155 308.771C254.569 309.704 253.809 310.355 252.897 310.703L252.919 310.681Z",
    fill: "url(#paint37_linear_2205_2999)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M248.403 308.055C249.206 308.51 249.879 309.639 250.053 310.768C249.51 310.616 248.968 310.399 248.403 310.073C247.839 309.748 247.274 309.379 246.753 308.923C246.927 307.99 247.6 307.599 248.403 308.055Z",
    fill: "url(#paint38_linear_2205_2999)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M254.981 302.629C254.981 301.587 255.481 301.023 256.176 301.109C256.306 301.977 256.393 302.846 256.393 303.692C256.393 304.343 256.349 304.973 256.262 305.559C255.524 304.907 254.981 303.692 254.981 302.629Z",
    fill: "url(#paint39_linear_2205_2999)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M254.374 296.833C253.44 296.313 252.68 294.858 252.68 293.6C252.68 293.252 252.745 292.97 252.832 292.731C253.722 294.034 254.482 295.488 255.068 297.029C254.851 297.029 254.613 296.985 254.374 296.855V296.833Z",
    fill: "url(#paint40_linear_2205_2999)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M288.124 301.029L288.4 300.905L288.417 300.602C288.649 296.534 288.059 293.302 287.407 291.081C287.082 289.971 286.74 289.113 286.478 288.53C286.347 288.238 286.236 288.015 286.157 287.863C286.117 287.787 286.085 287.728 286.063 287.688C286.052 287.668 286.043 287.652 286.037 287.641L286.029 287.628L286.027 287.624L286.026 287.623L286.026 287.623C286.025 287.622 286.025 287.622 285.595 287.877L286.025 287.622L285.958 287.509L285.843 287.443L245.916 264.611L245.695 264.485L245.463 264.588L235.215 269.168L235.612 270.086C238.356 268.939 241.259 268.933 243.499 269.225C244.616 269.371 245.559 269.589 246.221 269.771C246.551 269.862 246.811 269.943 246.987 270.001C247.075 270.03 247.142 270.054 247.186 270.069C247.208 270.077 247.225 270.083 247.235 270.087L247.246 270.091L247.249 270.092L247.249 270.092L247.249 270.092L247.249 270.092L247.249 270.092C258.274 274.259 263.926 283.817 266.824 292.413C268.271 296.705 269.024 300.738 269.414 303.699C269.609 305.179 269.714 306.389 269.769 307.227C269.797 307.646 269.813 307.973 269.822 308.193C269.826 308.303 269.829 308.387 269.83 308.443L269.832 308.505L269.832 308.521L269.832 308.524L269.832 308.525L269.843 309.286L270.538 308.973L288.124 301.029Z",
    fill: "#222222",
    stroke: "url(#paint41_linear_2205_2999)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M310.216 291.958V295.865L346.453 275.138V271.231L367.166 259.381L370.249 261.378L367.166 276.744L292.608 323.146L289.503 321.171V303.808L310.216 291.958Z",
    fill: "url(#paint42_linear_2205_2999)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M313.321 293.933V297.862L349.536 277.135V273.206L370.249 261.378V278.741L292.608 323.146V305.783L313.321 293.933Z",
    fill: "#222222"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3921 65.1701L327.398 196.628V309.065L97.3921 177.607V65.1701Z",
    fill: "#222222",
    stroke: "url(#paint43_linear_2205_2999)",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1799 66.7835L325.849 196.896V306.651L98.1799 176.538V66.7835ZM94.0112 59.5996V178.947L330.017 313.835V194.487L94.0112 59.5996Z",
    fill: "#222222"
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M192.042 7.2757L421.974 138.323L330.015 190.924L100.084 59.8559L192.042 7.2757Z",
    fill: "#222222",
    stroke: "url(#paint44_linear_2205_2999)",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M192.061 8.61779L419.643 138.34L330.017 189.582L102.435 59.8599L192.061 8.61779ZM192.061 3.82129L94.0547 59.8599L330.017 194.357L428.024 138.318L192.061 3.82129Z",
    fill: "#222222"
  }))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M425.024 256.013L333.017 308.641V196.119L425.024 143.49V256.013Z",
    fill: "#222222",
    stroke: "url(#paint45_linear_2205_2999)",
    strokeWidth: 6
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M423.855 145.502V255.344L334.164 306.651V196.809L423.855 145.502ZM428.024 138.318L330.017 194.379V313.813L428.024 257.753V138.318Z",
    fill: "#222222"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M423.855 145.502V255.344L334.164 306.651V196.809L423.855 145.502ZM428.024 138.318L330.017 194.379V313.813L428.024 257.753V138.318Z",
    fill: "#222222"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4817 126.88V90.7872L37.669 74.3359L29.9179 98.5137L29.5488 105.698L65.4817 126.88Z",
    fill: "#161C21"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5264 132.22L55.4727 127.293V124.559L64.5264 129.485V132.22Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M359.849 290.959L363.692 293.434L359.849 295.821L404.857 270.08V265.219L430.585 250.504L434.428 252.978L430.585 272.077L330.104 333.997L326.261 331.545V309.972L359.849 290.959Z",
    fill: "url(#paint46_linear_2205_2999)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M362.736 293.976V298.838L407.745 273.097V268.236L434.428 253V274.573L329.148 334.562V312.989L362.736 293.976Z",
    fill: "#222222"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M336.205 325.142L353.14 315.593V306.607L336.205 316.179V325.142Z",
    fill: "url(#paint47_linear_2205_2999)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M412.543 282.885L429.478 273.336V264.351L412.543 273.922V282.885Z",
    fill: "url(#paint48_linear_2205_2999)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M273.717 107.116C271.599 106.826 269.395 106.841 267.306 107.145C267.77 106.536 268.394 105.956 269.163 105.39C271.324 105.274 273.528 105.419 275.617 105.825C278.024 106.289 280.229 107.073 282.042 108.117L285.842 110.321C287.234 111.134 288.931 111.757 290.787 112.149C292.397 112.497 294.123 112.657 295.82 112.613C295.69 113.135 295.472 113.643 295.153 114.15C293.21 114.136 291.295 113.918 289.468 113.498C287.423 113.034 285.537 112.323 283.971 111.409L280.171 109.205C278.387 108.175 276.139 107.45 273.717 107.116Z",
    fill: "#161616"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M297.386 111.221C297.56 113.556 296.052 115.862 292.861 117.718C289.671 119.575 285.711 120.445 281.694 120.343C277.662 120.256 273.601 119.183 270.178 117.211C266.755 115.238 264.942 112.903 264.753 110.568C264.579 108.233 266.073 105.927 269.249 104.085C272.426 102.243 276.429 101.358 280.446 101.445C284.478 101.547 288.525 102.62 291.919 104.578C295.312 106.536 297.198 108.886 297.372 111.221H297.386ZM289.337 118.298C290.207 117.979 291.048 117.588 291.832 117.124C294.761 115.412 296.096 113.353 295.936 111.264C295.777 109.176 294.109 107.015 290.903 105.173C287.698 103.331 284.014 102.388 280.403 102.301C277.415 102.228 274.471 102.736 271.889 103.867C271.338 104.114 270.801 104.39 270.279 104.68C269.873 104.912 269.496 105.158 269.162 105.405C268.394 105.956 267.785 106.551 267.306 107.16C266.856 107.754 266.537 108.364 266.363 108.987C266.218 109.495 266.16 110.017 266.204 110.539C266.204 110.626 266.218 110.713 266.233 110.8C266.305 111.38 266.508 111.975 266.813 112.555C267.088 113.077 267.466 113.599 267.93 114.107C268.742 114.992 269.815 115.833 271.193 116.616C274.384 118.458 278.111 119.415 281.737 119.502C283.115 119.531 284.478 119.444 285.798 119.227C287.016 119.024 288.206 118.719 289.337 118.298Z",
    fill: "url(#paint49_linear_2205_2999)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M280.401 102.286C284.012 102.373 287.74 103.33 290.901 105.158C293.222 106.492 294.745 108.001 295.456 109.523C295.282 109.523 295.093 109.523 294.919 109.523C294.861 109.523 294.803 109.523 294.745 109.523C294.672 109.523 294.614 109.523 294.556 109.523C294.44 109.523 294.324 109.523 294.208 109.494C294.165 109.494 294.121 109.494 294.078 109.494C294.049 109.494 294.034 109.494 294.005 109.494C293.962 109.494 293.918 109.494 293.889 109.494C293.86 109.494 293.831 109.494 293.802 109.494C293.759 109.494 293.73 109.494 293.686 109.494C293.657 109.494 293.614 109.494 293.585 109.494C293.541 109.494 293.498 109.494 293.454 109.48C293.411 109.48 293.367 109.48 293.309 109.465C293.28 109.465 293.251 109.465 293.222 109.465C293.178 109.465 293.135 109.465 293.106 109.451C293.077 109.451 293.048 109.451 293.019 109.451C292.975 109.451 292.932 109.436 292.888 109.422C292.859 109.422 292.845 109.422 292.816 109.422C292.743 109.422 292.685 109.393 292.613 109.378C291.453 109.146 290.408 108.769 289.538 108.262L285.738 106.057C285.651 105.999 285.55 105.956 285.463 105.898C285.434 105.883 285.405 105.869 285.361 105.84C285.303 105.811 285.231 105.767 285.173 105.738C285.129 105.723 285.1 105.694 285.056 105.68C284.998 105.651 284.94 105.622 284.882 105.593C284.839 105.578 284.795 105.549 284.752 105.535C284.694 105.506 284.636 105.477 284.578 105.448C284.534 105.433 284.491 105.404 284.447 105.39C284.389 105.361 284.331 105.332 284.273 105.303C284.23 105.288 284.186 105.259 284.143 105.245C284.085 105.216 284.027 105.187 283.983 105.172C283.94 105.158 283.896 105.129 283.853 105.114C283.795 105.085 283.737 105.056 283.679 105.042C283.635 105.027 283.592 104.998 283.534 104.984C283.476 104.955 283.418 104.94 283.36 104.911C283.316 104.897 283.273 104.868 283.229 104.853C283.156 104.824 283.098 104.795 283.026 104.766C282.953 104.737 282.866 104.694 282.779 104.665C282.721 104.636 282.663 104.621 282.591 104.592C282.533 104.578 282.489 104.549 282.431 104.534C282.373 104.52 282.33 104.491 282.272 104.476C282.214 104.447 282.156 104.433 282.098 104.418C282.054 104.404 281.996 104.375 281.953 104.36C281.895 104.331 281.837 104.317 281.779 104.288C281.735 104.273 281.677 104.259 281.634 104.23C281.576 104.201 281.503 104.186 281.445 104.157C281.402 104.143 281.358 104.128 281.315 104.114C281.242 104.085 281.184 104.07 281.111 104.041C281.068 104.041 281.024 104.012 280.981 103.998C280.908 103.969 280.85 103.954 280.778 103.925C280.734 103.925 280.705 103.896 280.662 103.882C280.589 103.853 280.517 103.838 280.444 103.809C280.415 103.809 280.386 103.795 280.357 103.78C279.966 103.664 279.56 103.548 279.154 103.446C279.023 103.417 278.921 103.388 278.834 103.374C278.805 103.374 278.791 103.374 278.762 103.359C278.675 103.345 278.588 103.316 278.501 103.301C278.472 103.301 278.443 103.301 278.414 103.287C278.327 103.272 278.24 103.243 278.153 103.229C278.124 103.229 278.095 103.229 278.066 103.214C277.979 103.2 277.892 103.171 277.805 103.156C277.776 103.156 277.747 103.156 277.732 103.142C277.645 103.127 277.544 103.098 277.457 103.084C277.442 103.084 277.428 103.084 277.399 103.084C276.847 102.968 276.282 102.881 275.702 102.794C277.21 102.489 278.791 102.373 280.372 102.402L280.401 102.286Z",
    fill: "url(#paint50_linear_2205_2999)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M287.697 109.233L283.897 107.029C280.663 105.158 276.399 104.026 271.903 103.838C273.107 103.316 274.397 102.91 275.717 102.648C279.488 103.2 282.969 104.331 285.754 105.941L289.554 108.145C290.424 108.653 291.468 109.03 292.628 109.262C293.542 109.451 294.499 109.538 295.457 109.523C295.703 110.031 295.848 110.553 295.906 111.061C294.528 111.104 293.136 110.988 291.831 110.727C290.279 110.422 288.858 109.915 287.697 109.233Z",
    fill: "#161616"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M295.935 111.25C295.964 111.699 295.935 112.163 295.834 112.613C295.718 112.613 295.602 112.613 295.486 112.613C295.442 112.613 295.413 112.613 295.369 112.613C295.297 112.613 295.224 112.613 295.137 112.613C295.094 112.613 295.05 112.613 295.007 112.613C294.934 112.613 294.862 112.613 294.804 112.613C294.76 112.613 294.702 112.613 294.659 112.613C294.586 112.613 294.528 112.613 294.456 112.613C294.412 112.613 294.369 112.613 294.311 112.613C294.238 112.613 294.166 112.613 294.093 112.613C294.05 112.613 294.006 112.613 293.963 112.613C293.89 112.613 293.818 112.613 293.731 112.598C293.687 112.598 293.658 112.598 293.615 112.598C293.499 112.598 293.397 112.584 293.281 112.569C293.165 112.569 293.049 112.54 292.933 112.54C292.904 112.54 292.86 112.54 292.831 112.54C292.759 112.54 292.672 112.526 292.599 112.511C292.556 112.511 292.512 112.511 292.469 112.497C292.396 112.497 292.324 112.482 292.251 112.468C292.208 112.468 292.164 112.468 292.121 112.453C292.048 112.453 291.976 112.439 291.903 112.424C291.86 112.424 291.816 112.424 291.773 112.41C291.7 112.41 291.628 112.381 291.555 112.366C291.512 112.366 291.468 112.366 291.439 112.352C291.366 112.352 291.279 112.323 291.207 112.308C291.178 112.308 291.134 112.308 291.105 112.294C290.989 112.279 290.888 112.25 290.772 112.221C288.915 111.83 287.218 111.206 285.826 110.394L282.026 108.189C280.213 107.145 278.023 106.362 275.601 105.898C275.456 105.869 275.311 105.84 275.18 105.825C275.137 105.825 275.079 105.811 275.035 105.796C274.934 105.782 274.847 105.767 274.745 105.753C274.687 105.753 274.629 105.738 274.571 105.724C274.484 105.724 274.397 105.695 274.31 105.68C274.252 105.68 274.194 105.666 274.122 105.651C274.035 105.651 273.948 105.622 273.875 105.622C273.817 105.622 273.745 105.608 273.687 105.593C273.6 105.593 273.527 105.579 273.44 105.564C273.368 105.564 273.31 105.564 273.237 105.55C273.15 105.55 273.077 105.535 272.99 105.521C272.932 105.521 272.86 105.521 272.802 105.506C272.671 105.506 272.526 105.492 272.396 105.477C272.309 105.477 272.236 105.477 272.149 105.477C272.091 105.477 272.019 105.477 271.961 105.477C271.874 105.477 271.787 105.477 271.7 105.477C271.642 105.477 271.584 105.477 271.526 105.477C271.439 105.477 271.352 105.477 271.264 105.477C271.206 105.477 271.163 105.477 271.105 105.477C271.018 105.477 270.916 105.477 270.829 105.477C270.786 105.477 270.728 105.477 270.684 105.477C270.583 105.477 270.496 105.477 270.394 105.477C270.351 105.477 270.322 105.477 270.278 105.477C269.901 105.477 269.524 105.492 269.147 105.506C269.495 105.26 269.858 105.013 270.264 104.781C270.786 104.476 271.323 104.201 271.874 103.969C273.281 104.027 274.644 104.172 275.978 104.404C276.138 104.433 276.254 104.447 276.37 104.476C276.544 104.505 276.645 104.534 276.761 104.549C276.79 104.549 276.805 104.549 276.834 104.549C276.95 104.578 277.051 104.592 277.167 104.621C277.196 104.621 277.225 104.621 277.24 104.636C277.342 104.665 277.458 104.679 277.559 104.708C277.588 104.708 277.603 104.708 277.632 104.723C277.733 104.752 277.849 104.781 277.951 104.795C277.98 104.795 277.994 104.795 278.023 104.81C278.125 104.839 278.241 104.868 278.342 104.897C278.879 105.042 279.358 105.187 279.836 105.332C279.938 105.361 280.025 105.39 280.112 105.419C280.155 105.419 280.184 105.448 280.228 105.463C280.3 105.492 280.373 105.521 280.46 105.55C280.503 105.564 280.561 105.579 280.605 105.608C280.677 105.637 280.75 105.666 280.808 105.68C280.866 105.695 280.909 105.724 280.967 105.738C281.04 105.767 281.098 105.796 281.17 105.811C281.228 105.84 281.286 105.854 281.344 105.883C281.403 105.912 281.475 105.941 281.533 105.956C281.591 105.985 281.649 105.999 281.707 106.028C281.765 106.057 281.823 106.086 281.881 106.101C281.939 106.13 281.997 106.159 282.055 106.173C282.113 106.202 282.171 106.217 282.229 106.246C282.287 106.275 282.345 106.304 282.418 106.333C282.476 106.362 282.519 106.376 282.577 106.405C282.635 106.434 282.708 106.463 282.766 106.492C282.809 106.521 282.867 106.536 282.911 106.565C282.983 106.594 283.041 106.637 283.099 106.666C283.143 106.695 283.186 106.71 283.23 106.739C283.302 106.782 283.375 106.811 283.448 106.855C283.491 106.869 283.52 106.898 283.564 106.913C283.665 106.971 283.781 107.029 283.883 107.087L287.683 109.292C288.843 109.959 290.264 110.466 291.816 110.785C291.903 110.8 291.99 110.814 292.092 110.843C292.121 110.843 292.164 110.843 292.193 110.858C292.251 110.858 292.309 110.872 292.367 110.887C292.411 110.887 292.454 110.887 292.483 110.901C292.527 110.901 292.585 110.916 292.628 110.93C292.672 110.93 292.715 110.93 292.759 110.945C292.802 110.945 292.846 110.945 292.904 110.959C292.947 110.959 292.991 110.959 293.049 110.974C293.092 110.974 293.136 110.974 293.165 110.988C293.223 110.988 293.266 110.988 293.324 111.003C293.513 111.017 293.658 111.032 293.818 111.047C293.919 111.047 293.992 111.047 294.064 111.061C294.195 111.061 294.267 111.061 294.34 111.076C294.47 111.076 294.543 111.076 294.615 111.076C295.065 111.09 295.5 111.09 295.921 111.076C295.921 111.134 295.921 111.206 295.935 111.264V111.25Z",
    fill: "url(#paint51_linear_2205_2999)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M295.166 114.151C294.847 114.659 294.412 115.166 293.875 115.645C293.745 115.645 293.614 115.645 293.484 115.616C293.339 115.616 293.208 115.601 293.092 115.587C292.933 115.587 292.817 115.558 292.686 115.558C292.512 115.543 292.396 115.529 292.28 115.514C292.251 115.514 292.222 115.514 292.193 115.514C292.077 115.514 291.975 115.485 291.859 115.485C291.83 115.485 291.801 115.485 291.772 115.485C291.671 115.485 291.555 115.456 291.453 115.442C291.424 115.442 291.395 115.442 291.366 115.442C291.265 115.442 291.163 115.413 291.047 115.398C291.018 115.398 290.989 115.398 290.946 115.398C290.844 115.384 290.742 115.369 290.641 115.355C290.612 115.355 290.583 115.355 290.554 115.34C290.452 115.326 290.351 115.311 290.249 115.297C290.22 115.297 290.191 115.297 290.162 115.282C290.061 115.268 289.959 115.253 289.858 115.224C289.829 115.224 289.8 115.224 289.771 115.21C289.669 115.195 289.553 115.166 289.452 115.152C289.278 115.123 289.162 115.094 289.06 115.065C288.422 114.934 287.827 114.789 287.247 114.615C287.218 114.615 287.189 114.601 287.146 114.586C287.059 114.557 286.986 114.543 286.899 114.514C286.856 114.514 286.812 114.485 286.769 114.47C286.696 114.441 286.623 114.427 286.536 114.398C286.493 114.383 286.435 114.369 286.391 114.354C286.319 114.325 286.246 114.31 286.174 114.281C286.116 114.267 286.072 114.252 286.014 114.223C285.942 114.194 285.884 114.18 285.811 114.151C285.753 114.136 285.695 114.107 285.652 114.093C285.579 114.064 285.521 114.049 285.463 114.02C285.405 114.006 285.347 113.977 285.304 113.962C285.246 113.933 285.173 113.919 285.115 113.89C285.057 113.861 284.999 113.846 284.941 113.817C284.883 113.788 284.825 113.774 284.767 113.745C284.709 113.716 284.651 113.701 284.593 113.672C284.535 113.643 284.477 113.629 284.419 113.6C284.361 113.571 284.303 113.556 284.245 113.527C284.187 113.498 284.129 113.484 284.085 113.455C284.027 113.426 283.969 113.397 283.911 113.382C283.853 113.353 283.81 113.339 283.752 113.31C283.694 113.281 283.636 113.252 283.578 113.223C283.52 113.194 283.476 113.179 283.418 113.15C283.36 113.121 283.302 113.092 283.23 113.063C283.186 113.034 283.128 113.02 283.085 112.991C283.027 112.962 282.954 112.933 282.896 112.889C282.853 112.86 282.809 112.846 282.766 112.817C282.693 112.773 282.62 112.744 282.548 112.701C282.519 112.686 282.475 112.657 282.446 112.643C282.345 112.585 282.243 112.527 282.142 112.469L278.342 110.264C276.674 109.307 274.542 108.683 272.236 108.495C272.12 108.495 272.004 108.48 271.888 108.466C271.728 108.466 271.612 108.451 271.511 108.451C271.337 108.451 271.235 108.451 271.119 108.451C270.96 108.451 270.844 108.451 270.728 108.451C270.612 108.451 270.495 108.451 270.379 108.451C270.22 108.451 270.118 108.451 270.002 108.451C269.843 108.451 269.727 108.451 269.611 108.466C269.35 108.48 269.118 108.495 268.886 108.524C268.741 108.538 268.625 108.553 268.523 108.567C268.363 108.582 268.262 108.596 268.146 108.611C267.899 108.654 267.667 108.683 267.435 108.727C267.305 108.756 267.189 108.77 267.087 108.799C266.942 108.828 266.841 108.857 266.725 108.886C266.609 108.915 266.492 108.944 266.376 108.973C266.551 108.35 266.87 107.74 267.319 107.146C267.464 107.131 267.595 107.102 267.74 107.088C267.783 107.088 267.827 107.088 267.856 107.073C267.957 107.073 268.059 107.044 268.16 107.044C268.218 107.044 268.262 107.044 268.32 107.03C268.407 107.03 268.494 107.015 268.596 107.001C268.654 107.001 268.712 107.001 268.77 107.001C268.857 107.001 268.944 107.001 269.031 106.986C269.089 106.986 269.147 106.986 269.205 106.986C269.292 106.986 269.379 106.986 269.48 106.972C269.538 106.972 269.596 106.972 269.64 106.972C269.741 106.972 269.843 106.972 269.93 106.972C269.973 106.972 270.017 106.972 270.075 106.972C270.22 106.972 270.365 106.972 270.51 106.972C270.655 106.972 270.8 106.972 270.945 106.972C270.989 106.972 271.032 106.972 271.09 106.972C271.192 106.972 271.293 106.972 271.38 106.972C271.438 106.972 271.496 106.972 271.554 106.972C271.641 106.972 271.728 106.972 271.815 106.972C271.873 106.972 271.931 106.972 271.989 106.972C272.076 106.972 272.163 106.972 272.25 106.986C272.308 106.986 272.366 106.986 272.424 106.986C272.511 106.986 272.599 107.001 272.7 107.015C272.758 107.015 272.816 107.015 272.874 107.03C272.976 107.03 273.063 107.044 273.164 107.059C273.208 107.059 273.266 107.059 273.309 107.073C273.454 107.088 273.599 107.102 273.744 107.131C276.166 107.465 278.414 108.19 280.198 109.22L283.998 111.424C285.579 112.338 287.45 113.049 289.495 113.513C289.611 113.542 289.742 113.571 289.858 113.6C289.901 113.6 289.945 113.614 289.974 113.629C290.061 113.643 290.133 113.658 290.22 113.687C290.264 113.687 290.322 113.701 290.365 113.716C290.438 113.716 290.51 113.745 290.583 113.759C290.641 113.759 290.684 113.774 290.742 113.788C290.815 113.788 290.888 113.817 290.96 113.832C291.018 113.832 291.076 113.846 291.134 113.861C291.207 113.861 291.265 113.875 291.337 113.89C291.395 113.89 291.453 113.904 291.511 113.919C291.584 113.919 291.642 113.933 291.714 113.948C291.772 113.948 291.83 113.962 291.903 113.977C291.961 113.977 292.033 113.991 292.091 114.006C292.149 114.006 292.222 114.02 292.28 114.035C292.323 114.035 292.367 114.035 292.41 114.035C292.57 114.049 292.715 114.064 292.875 114.078C292.918 114.078 292.976 114.078 293.02 114.078C293.092 114.078 293.179 114.078 293.252 114.093C293.295 114.093 293.353 114.093 293.397 114.093C293.469 114.093 293.556 114.093 293.629 114.107C293.672 114.107 293.73 114.107 293.774 114.107C293.846 114.107 293.933 114.107 294.006 114.107C294.049 114.107 294.093 114.107 294.151 114.107C294.238 114.107 294.31 114.107 294.397 114.107C294.441 114.107 294.484 114.107 294.528 114.107C294.615 114.107 294.702 114.107 294.789 114.107C294.818 114.107 294.862 114.107 294.891 114.107C294.978 114.107 295.079 114.107 295.166 114.107V114.151Z",
    fill: "url(#paint52_linear_2205_2999)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M291.932 117.052C291.932 117.052 291.86 117.095 291.831 117.11C291.048 117.574 290.206 117.965 289.336 118.284C288.422 118.139 287.552 117.98 286.697 117.777C286.58 117.748 286.464 117.719 286.363 117.704C286.203 117.661 286.102 117.646 286 117.617C285.971 117.617 285.957 117.617 285.928 117.603C285.826 117.574 285.739 117.559 285.638 117.53C285.609 117.53 285.58 117.516 285.551 117.501C285.464 117.472 285.362 117.458 285.275 117.429C285.246 117.429 285.217 117.414 285.188 117.4C285.101 117.371 285 117.356 284.913 117.327C284.884 117.327 284.855 117.313 284.811 117.298C284.724 117.269 284.637 117.24 284.535 117.226C284.506 117.226 284.477 117.211 284.448 117.197C284.361 117.168 284.274 117.139 284.187 117.11C284.158 117.11 284.129 117.095 284.1 117.081C284.013 117.052 283.926 117.023 283.839 116.994C283.81 116.994 283.781 116.979 283.752 116.965C283.665 116.936 283.564 116.907 283.477 116.878C283.114 116.762 282.795 116.646 282.49 116.53C282.389 116.486 282.302 116.457 282.229 116.428C282.186 116.414 282.142 116.399 282.113 116.385C282.041 116.355 281.983 116.326 281.91 116.312C281.867 116.297 281.809 116.268 281.765 116.254C281.707 116.225 281.635 116.21 281.577 116.181C281.519 116.167 281.475 116.138 281.417 116.123C281.359 116.094 281.301 116.08 281.243 116.051C281.185 116.022 281.142 116.007 281.084 115.978C281.026 115.949 280.968 115.935 280.91 115.906C280.852 115.877 280.808 115.862 280.75 115.833C280.692 115.804 280.648 115.79 280.59 115.761C280.532 115.732 280.474 115.703 280.416 115.688C280.358 115.659 280.315 115.645 280.257 115.616C280.199 115.587 280.141 115.558 280.083 115.529C280.039 115.5 279.981 115.485 279.938 115.456C279.88 115.427 279.822 115.398 279.764 115.369C279.72 115.34 279.662 115.326 279.619 115.297C279.561 115.268 279.503 115.239 279.445 115.21C279.401 115.181 279.358 115.166 279.314 115.137C279.256 115.108 279.198 115.079 279.126 115.036C279.082 115.007 279.039 114.992 278.995 114.963C278.923 114.934 278.865 114.891 278.792 114.862C278.763 114.847 278.72 114.818 278.691 114.804C278.589 114.746 278.487 114.688 278.386 114.63L274.586 112.425C273.571 111.845 272.222 111.511 270.815 111.511C269.394 111.511 268.045 111.816 267.059 112.396L266.812 112.541C266.493 111.961 266.304 111.366 266.232 110.786C266.58 110.641 266.943 110.525 267.32 110.424C267.61 110.337 267.9 110.278 268.19 110.22C268.306 110.191 268.407 110.177 268.494 110.162C268.712 110.133 268.901 110.104 269.104 110.075C269.234 110.061 269.321 110.046 269.423 110.046C269.568 110.046 269.655 110.032 269.756 110.017C269.872 110.017 269.974 110.017 270.061 110.003C270.191 110.003 270.278 110.003 270.38 110.003C270.525 110.003 270.612 110.003 270.714 110.003C270.859 110.003 270.96 110.003 271.062 110.003C273.078 110.046 275.021 110.554 276.457 111.381L280.271 113.571C280.373 113.629 280.431 113.658 280.489 113.687C280.532 113.716 280.561 113.73 280.605 113.759C280.707 113.817 280.794 113.861 280.895 113.919C280.91 113.919 280.939 113.948 280.953 113.948C281.04 113.991 281.142 114.049 281.229 114.093C281.272 114.107 281.316 114.136 281.359 114.151C281.432 114.18 281.49 114.223 281.562 114.252C281.606 114.281 281.664 114.296 281.707 114.325C281.765 114.354 281.838 114.383 281.896 114.412C281.939 114.441 281.997 114.456 282.041 114.485C282.099 114.514 282.171 114.543 282.229 114.572C282.287 114.601 282.331 114.615 282.389 114.644C282.447 114.673 282.505 114.702 282.577 114.731C282.635 114.76 282.694 114.775 282.752 114.804C282.81 114.833 282.868 114.847 282.926 114.876C282.984 114.905 283.042 114.92 283.1 114.949C283.158 114.978 283.216 114.992 283.274 115.021C283.332 115.05 283.39 115.065 283.448 115.094C283.506 115.123 283.564 115.137 283.636 115.166C283.694 115.195 283.752 115.21 283.81 115.239C283.868 115.268 283.941 115.282 283.999 115.311C284.057 115.326 284.115 115.355 284.173 115.369C284.231 115.398 284.303 115.413 284.361 115.442C284.419 115.456 284.477 115.485 284.535 115.5C284.593 115.514 284.666 115.543 284.724 115.558C284.782 115.572 284.84 115.601 284.913 115.616C284.971 115.63 285.043 115.659 285.101 115.674C285.159 115.688 285.217 115.717 285.275 115.732C285.348 115.746 285.42 115.775 285.478 115.79C285.536 115.804 285.594 115.819 285.652 115.848C285.725 115.877 285.812 115.891 285.899 115.92C285.971 115.935 286.044 115.964 286.116 115.978C286.218 116.007 286.319 116.036 286.421 116.065C286.479 116.08 286.537 116.094 286.595 116.109C286.667 116.123 286.74 116.152 286.813 116.167C286.871 116.181 286.943 116.196 287.001 116.21C287.074 116.225 287.146 116.239 287.204 116.268C287.262 116.283 287.335 116.297 287.393 116.312C287.465 116.326 287.523 116.341 287.596 116.356C287.654 116.37 287.726 116.385 287.784 116.399C287.857 116.414 287.915 116.428 287.987 116.443C288.045 116.443 288.118 116.472 288.176 116.486C288.248 116.501 288.321 116.515 288.393 116.53C288.451 116.53 288.524 116.559 288.582 116.573C288.654 116.573 288.727 116.602 288.785 116.617C288.858 116.617 288.916 116.646 288.988 116.66C289.061 116.66 289.133 116.689 289.191 116.704C289.264 116.704 289.322 116.733 289.394 116.733C289.467 116.733 289.539 116.762 289.612 116.762C289.684 116.762 289.742 116.791 289.815 116.791C289.887 116.791 289.96 116.82 290.032 116.82C290.105 116.82 290.163 116.834 290.235 116.849C290.308 116.849 290.38 116.863 290.453 116.878C290.525 116.878 290.583 116.892 290.656 116.907C290.728 116.907 290.801 116.921 290.874 116.936C290.946 116.936 291.004 116.95 291.077 116.965C291.149 116.965 291.236 116.979 291.309 116.994C291.367 116.994 291.439 117.008 291.497 117.023C291.584 117.023 291.671 117.037 291.744 117.052C291.802 117.052 291.86 117.052 291.918 117.066L291.932 117.052Z",
    fill: "url(#paint53_linear_2205_2999)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M280.3 113.584L276.442 111.365C274.992 110.524 273.063 110.031 271.047 109.987C269.321 109.944 267.638 110.234 266.231 110.799C266.231 110.712 266.217 110.625 266.202 110.538C266.159 110.016 266.202 109.494 266.362 108.986C268.175 108.522 270.205 108.348 272.207 108.522C274.513 108.711 276.645 109.334 278.313 110.292L282.113 112.496C285.289 114.338 289.466 115.455 293.861 115.658C293.324 116.151 292.671 116.615 291.917 117.065C287.537 116.644 283.462 115.426 280.285 113.599L280.3 113.584Z",
    fill: "#161616"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M274.585 112.438L278.385 114.643C281.416 116.398 285.202 117.66 289.321 118.283C288.19 118.704 287.015 119.008 285.782 119.211C282.33 118.428 279.183 117.239 276.514 115.716L272.714 113.512C272.207 113.221 271.525 113.047 270.829 113.047C270.118 113.047 269.451 113.192 268.943 113.483L267.914 114.077C267.45 113.57 267.072 113.047 266.797 112.525L267.043 112.38C268.03 111.815 269.379 111.481 270.8 111.496C272.207 111.496 273.556 111.829 274.571 112.409L274.585 112.438Z",
    fill: "#161616"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M285.377 119.125C285.377 119.125 285.435 119.14 285.464 119.154C285.58 119.183 285.681 119.212 285.797 119.227C284.477 119.444 283.114 119.531 281.736 119.502C278.125 119.415 274.397 118.458 271.192 116.616C269.829 115.833 268.741 114.977 267.929 114.107L268.958 113.512C269.452 113.222 270.133 113.063 270.844 113.077C271.54 113.077 272.222 113.237 272.729 113.541L276.529 115.746C276.616 115.789 276.703 115.847 276.79 115.891C276.819 115.905 276.848 115.92 276.877 115.934C276.935 115.963 276.993 116.007 277.066 116.036C277.095 116.05 277.138 116.079 277.168 116.094C277.226 116.123 277.284 116.152 277.327 116.181C277.371 116.195 277.4 116.224 277.443 116.239C277.501 116.268 277.545 116.297 277.603 116.326C277.646 116.34 277.675 116.369 277.719 116.384C277.777 116.413 277.82 116.442 277.878 116.471C277.922 116.485 277.965 116.514 277.994 116.529C278.052 116.558 278.096 116.587 278.154 116.601C278.197 116.616 278.241 116.645 278.284 116.659C278.342 116.688 278.386 116.717 278.444 116.732C278.487 116.746 278.531 116.775 278.574 116.79C278.632 116.819 278.69 116.848 278.734 116.863C278.777 116.877 278.821 116.906 278.85 116.921C278.908 116.95 278.966 116.979 279.038 117.008C279.067 117.022 279.111 117.037 279.14 117.051C279.242 117.095 279.329 117.138 279.43 117.182C279.459 117.182 279.503 117.211 279.532 117.225C279.604 117.254 279.662 117.283 279.735 117.312C279.778 117.327 279.822 117.341 279.865 117.37C279.923 117.399 279.981 117.414 280.039 117.443C280.083 117.457 280.126 117.486 280.184 117.501C280.242 117.53 280.286 117.544 280.344 117.573C280.387 117.588 280.431 117.617 280.489 117.631C280.547 117.646 280.605 117.675 280.648 117.689C280.692 117.704 280.75 117.733 280.793 117.747C280.851 117.762 280.895 117.791 280.953 117.805C280.996 117.82 281.054 117.849 281.098 117.863C281.156 117.878 281.2 117.907 281.258 117.921C281.301 117.936 281.359 117.95 281.403 117.979C281.461 117.994 281.519 118.023 281.577 118.037C281.62 118.052 281.678 118.066 281.722 118.081C281.78 118.095 281.838 118.124 281.91 118.139C281.954 118.153 281.997 118.168 282.041 118.182C282.113 118.211 282.2 118.24 282.273 118.255C282.316 118.269 282.374 118.284 282.418 118.298C282.505 118.327 282.577 118.356 282.664 118.385C282.708 118.385 282.751 118.414 282.795 118.429C282.853 118.443 282.925 118.472 282.983 118.487C283.027 118.501 283.085 118.516 283.128 118.53C283.186 118.545 283.245 118.574 283.317 118.588C283.361 118.588 283.419 118.617 283.462 118.632C283.52 118.646 283.578 118.661 283.651 118.69C283.694 118.69 283.752 118.719 283.796 118.733C283.854 118.748 283.912 118.762 283.984 118.792C284.028 118.792 284.086 118.821 284.129 118.835C284.187 118.85 284.26 118.864 284.318 118.879C284.361 118.879 284.419 118.908 284.463 118.922C284.521 118.937 284.593 118.951 284.651 118.98C284.695 118.98 284.738 119.009 284.796 119.009C284.869 119.024 284.941 119.053 285.014 119.067C285.057 119.067 285.086 119.082 285.13 119.096C285.217 119.111 285.29 119.14 285.377 119.154V119.125Z",
    fill: "url(#paint54_linear_2205_2999)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M306.03 112.686C311.425 115.804 311.744 119.212 306.972 121.983L283.752 135.471L277.791 132.034L300.823 118.647C303.114 117.312 302.955 116.471 300.924 115.296L300.272 114.919L305.087 112.12L306.044 112.671L306.03 112.686Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M330.092 126.013C336.822 129.9 337.199 135.209 330.861 138.893C324.523 142.577 315.371 142.373 308.627 138.487C301.882 134.6 301.563 129.277 307.858 125.622C314.152 121.967 323.406 122.155 330.092 126.013ZM313.442 135.687C316.908 137.689 320.317 137.848 324.668 135.31C329.019 132.772 328.743 130.8 325.291 128.798C321.839 126.797 318.46 126.623 314.065 129.175C309.671 131.728 310.033 133.7 313.456 135.673",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M368.961 149.031L341.462 165L335.196 161.389L345.581 155.355L334.282 148.828L323.898 154.862L317.632 151.251L345.131 135.268L351.397 138.879L339.547 145.768L350.86 152.295L362.695 145.406L368.961 149.031Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M251.061 80.951L230.596 92.844L224.635 89.4066L227.623 87.6807C224.447 88.3334 220.922 87.8402 218.152 86.2448C217.267 85.7372 216.528 85.1426 216.223 84.6494L221.72 81.4586C222.068 81.9663 222.837 82.5899 223.997 83.2426C227.391 85.2006 231.249 85.5777 235.556 83.0685L245.1 77.5137L251.061 80.951Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M208.276 56.251L192.612 65.3447L196.687 67.6943L191.872 70.4935L187.797 68.1439L184.968 69.7973C180.472 72.408 173.641 72.2774 169.305 69.7683C169.261 69.7538 169.232 69.7248 169.189 69.7103C167.796 68.9126 166.592 68.0134 165.577 67.0416L170.349 64.2715C171.074 65.0401 171.988 65.7508 173.061 66.3745C173.09 66.389 173.119 66.4035 173.148 66.4325C174.961 67.4768 176.875 67.6073 179.051 66.3455L181.836 64.7211L176.063 61.3852L180.878 58.586L186.651 61.9219L202.315 52.8281L208.276 56.2655V56.251Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M186.869 43.198C192.583 46.4903 193.468 49.5796 189.973 52.8574L184.331 49.6086C185.39 48.5353 185.564 47.6941 182.518 45.9392C179.922 44.4308 178.297 43.9957 177.036 44.7354C175.585 45.5766 175.875 46.0697 178.529 48.3613C181.561 50.9574 185.433 54.6559 180.749 57.3825C176.412 59.9062 170.161 58.5573 165.172 55.6711C160.182 52.7849 158.964 49.5071 162.155 46.5338L167.797 49.7826C167.028 50.8559 167.101 51.5231 169.523 52.9154C172.09 54.3948 173.511 54.5833 174.701 53.9017C175.817 53.249 175.397 52.5238 172.67 50.2032C169.479 47.4766 165.984 44.0827 170.553 41.4286C175.426 38.6004 181.996 40.3843 186.869 43.198Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M208.566 75.4971C210.567 76.6573 211.902 77.0779 213.903 76.4978L219.705 79.8481C213.7 81.6466 208.522 80.6893 204.099 78.1367C197.877 74.5398 197.383 70.8559 202.503 67.8827L208.885 64.1843C210.219 63.4156 209.987 62.8354 209.001 62.2553L208.508 61.9652L213.323 59.166L214.208 59.6736C217.587 61.6316 217.935 62.8499 217.21 64.2858C219.893 63.7927 223.954 64.7354 227.304 66.6644C231.539 69.101 233.541 72.7124 228.958 75.3665C224.375 78.0207 217.79 76.3818 213.366 73.8291C213.308 73.8001 213.25 73.7566 213.192 73.7276C211.655 72.8429 210.495 71.7551 209.784 70.5658L208.261 71.4506C205.883 72.8284 205.709 73.8291 208.595 75.4826L208.566 75.4971ZM215.571 67.201L213.584 68.3613C213.889 69.3765 214.44 70.1887 216.847 71.5811C219.255 72.9734 220.807 73.0314 222.605 71.9872C224.288 71.0154 224.244 70.1452 222.011 68.8544C219.777 67.5636 218.167 66.9835 215.571 67.2155",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M266.972 90.9444C272.237 93.9901 272.948 99.2694 267.146 102.649C261.345 106.028 252.309 105.97 246.696 102.736C243.317 100.778 243.041 98.8053 243.679 97.326L241.011 98.8778L235.05 95.4405L253.005 85.0124C259.909 80.9949 267.132 80.6903 275.355 85.433C281.505 88.9864 281.403 92.2497 278.778 95.4695L273.049 92.1627C274.122 90.8283 273.151 89.61 270.584 88.1307C266.624 85.8391 264.086 85.491 259.662 88.0582L257.98 89.0299C260.779 88.6528 263.448 88.9139 266.987 90.9589L266.972 90.9444ZM250.743 99.5305C253.672 101.213 257.11 101.314 260.968 99.0664C265.29 96.5573 264.826 94.7733 261.823 93.0474C257.98 90.8283 255.717 91.0314 252.396 92.2497L249.191 94.1207C247.407 96.1802 247.175 97.471 250.757 99.5305",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.017 200.304C218.427 206.713 227.199 208.728 234.534 205.954C233.684 209.175 232.5 211.885 231.031 214.092C224.037 214.658 216.385 211.995 209.016 206.384L199.561 199.194C197.42 197.555 195.185 196.579 193.06 196.321C191.097 196.093 189.281 196.475 187.684 197.446C186.479 195.34 185.401 193.176 184.467 190.956C186.626 189.561 189.142 188.982 191.839 189.284C194.695 189.616 197.697 190.922 200.58 193.101L210.036 200.291L210.017 200.304Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.112 202.143L236.864 202.718L236.693 203.698L235.957 203.125L236.112 202.143Z",
    fill: "url(#paint55_linear_2205_2999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.505 164.959L226.822 163.045C228.321 165.44 229.631 167.948 230.796 170.527C230.774 170.639 230.74 170.732 230.705 170.825C230.653 171.014 230.621 171.091 230.603 171.187C230.55 171.376 230.515 171.469 230.484 171.546C230.415 171.732 230.381 171.825 230.366 171.905C230.297 172.09 230.265 172.167 230.231 172.26C230.162 172.446 230.131 172.523 230.099 172.6C230.014 172.783 229.983 172.86 229.952 172.937C229.867 173.12 229.836 173.197 229.804 173.274C229.719 173.456 229.672 173.53 229.644 173.591C229.543 173.771 229.515 173.832 229.483 173.909C229.382 174.089 229.354 174.15 229.31 174.207C229.212 174.371 229.165 174.445 229.136 174.506C229.039 174.67 228.994 174.728 228.95 174.786C228.745 175.078 228.587 175.296 228.428 175.515C228.337 175.647 228.296 175.689 228.254 175.731C228.232 175.759 228.191 175.801 228.169 175.83C228.128 175.872 228.086 175.914 228.061 175.959C228.02 176.001 227.998 176.03 227.957 176.072C227.915 176.113 227.874 176.155 227.849 176.2C227.808 176.242 227.783 176.287 227.744 176.313C227.703 176.355 227.665 176.381 227.64 176.426C227.599 176.467 227.557 176.509 227.519 176.535C227.478 176.577 227.44 176.603 227.415 176.648C227.373 176.69 227.332 176.732 227.294 176.757C227.256 176.783 227.215 176.825 227.177 176.851C227.135 176.893 227.097 176.919 227.056 176.961C227.018 176.987 226.977 177.028 226.939 177.054C226.897 177.096 226.859 177.122 226.802 177.161C226.764 177.187 226.726 177.213 226.684 177.254C226.643 177.296 226.589 177.319 226.548 177.361C226.51 177.387 226.472 177.413 226.433 177.439C226.392 177.48 226.338 177.503 226.297 177.545C226.259 177.571 226.221 177.597 226.182 177.623C226.128 177.645 226.087 177.687 226.033 177.71C225.995 177.736 225.957 177.762 225.918 177.788C225.864 177.811 225.823 177.852 225.769 177.875C225.731 177.901 225.696 177.911 225.658 177.937C225.603 177.96 225.546 177.998 225.492 178.021C225.454 178.047 225.419 178.057 225.381 178.083C225.326 178.106 225.269 178.144 225.215 178.167C225.18 178.177 225.142 178.203 225.107 178.213C225.053 178.236 224.979 178.271 224.925 178.294C224.744 178.375 224.639 178.405 224.549 178.438C221.407 179.594 217.674 178.728 214.083 175.998L204.625 168.824C204.493 168.733 204.365 168.625 204.233 168.534C204.03 168.379 203.943 168.312 203.841 168.243C203.783 168.198 203.738 168.173 203.68 168.129C203.609 168.065 203.519 168.015 203.445 167.968C203.388 167.923 203.33 167.879 203.269 167.851C203.195 167.803 203.124 167.74 203.05 167.693C202.992 167.648 202.918 167.601 202.861 167.557C202.787 167.509 202.729 167.465 202.655 167.418C202.581 167.37 202.523 167.326 202.449 167.279C202.391 167.235 202.318 167.187 202.26 167.143C202.202 167.099 202.128 167.051 202.07 167.007C202.012 166.963 201.938 166.915 201.88 166.871C201.807 166.824 201.749 166.779 201.675 166.732C201.617 166.688 201.543 166.64 201.482 166.612C201.408 166.565 201.35 166.52 201.277 166.473C201.219 166.429 201.158 166.401 201.1 166.356C201.026 166.309 200.952 166.262 200.894 166.217C200.836 166.173 200.775 166.145 200.718 166.1C200.644 166.053 200.57 166.006 200.493 165.974C200.432 165.946 200.374 165.902 200.313 165.873C200.239 165.826 200.165 165.779 200.088 165.747C200.027 165.719 199.986 165.678 199.925 165.65C199.851 165.602 199.777 165.555 199.684 165.52C199.623 165.492 199.578 165.467 199.52 165.423C199.446 165.375 199.356 165.325 199.28 165.294C199.235 165.268 199.174 165.24 199.129 165.215C199.055 165.167 198.965 165.117 198.888 165.086C198.843 165.06 198.782 165.032 198.737 165.007C198.663 164.96 198.57 164.925 198.497 164.878C198.448 164.869 198.407 164.827 198.346 164.799C198.256 164.749 198.179 164.717 198.089 164.667C198.041 164.658 197.999 164.616 197.954 164.591C197.864 164.541 197.787 164.509 197.697 164.459C197.649 164.45 197.608 164.409 197.563 164.383C197.473 164.333 197.396 164.302 197.306 164.251C197.258 164.242 197.216 164.201 197.168 164.192C197.078 164.141 197.001 164.11 196.911 164.059C196.863 164.05 196.818 164.025 196.789 164.003C196.7 163.952 196.607 163.918 196.514 163.884C196.466 163.874 196.437 163.852 196.392 163.827C196.299 163.793 196.209 163.742 196.116 163.708C195.917 163.62 195.811 163.566 195.718 163.532C195.52 163.444 195.427 163.409 195.321 163.356C195.138 163.271 195.029 163.234 194.92 163.196C194.734 163.127 194.628 163.074 194.535 163.039C194.349 162.971 194.24 162.933 194.135 162.88C193.965 162.814 193.856 162.776 193.747 162.739C193.593 162.676 193.468 162.635 193.359 162.598C193.218 162.554 193.093 162.514 192.971 162.457C188.572 160.999 184.28 160.624 180.237 161.375C180.289 161.02 180.34 160.664 180.408 160.312C180.786 157.996 181.325 155.876 181.988 153.979C182.103 153.984 182.205 153.971 182.304 153.973C182.454 153.969 182.554 153.971 182.672 153.961C182.822 153.956 182.921 153.959 183.02 153.961C183.186 153.96 183.285 153.962 183.368 153.961C183.535 153.96 183.634 153.963 183.733 153.965C183.899 153.964 183.998 153.966 184.094 153.985C184.257 153.999 184.356 154.002 184.455 154.004C184.618 154.019 184.717 154.021 184.817 154.024C184.98 154.038 185.079 154.041 185.178 154.043C185.341 154.058 185.44 154.06 185.536 154.079C185.696 154.109 185.795 154.112 185.894 154.114C186.07 154.148 186.169 154.15 186.268 154.153C186.428 154.184 186.528 154.186 186.64 154.207C186.8 154.238 186.912 154.26 187.011 154.262C187.187 154.296 187.283 154.314 187.379 154.333C187.539 154.363 187.651 154.385 187.747 154.403C187.923 154.437 188.019 154.456 188.115 154.474C188.291 154.508 188.387 154.526 188.483 154.545C188.643 154.575 188.755 154.597 188.851 154.615C189.011 154.646 189.107 154.664 189.219 154.686C189.363 154.713 189.475 154.735 189.587 154.756C189.731 154.784 189.843 154.806 189.952 154.843C191.329 155.19 192.675 155.614 194.037 156.124C194.162 156.165 194.268 156.218 194.377 156.256C194.515 156.316 194.623 156.353 194.732 156.391C194.886 156.453 194.995 156.491 195.101 156.544C195.271 156.61 195.361 156.661 195.47 156.698C195.653 156.783 195.746 156.817 195.839 156.852C196.037 156.94 196.13 156.974 196.204 157.021C196.252 157.031 196.281 157.053 196.326 157.078C196.419 157.112 196.493 157.16 196.586 157.194C196.634 157.203 196.663 157.226 196.708 157.251C196.785 157.282 196.875 157.333 196.952 157.364C197 157.373 197.044 157.398 197.089 157.424C197.166 157.455 197.256 157.505 197.333 157.537C197.381 157.546 197.423 157.587 197.471 157.596C197.548 157.628 197.622 157.675 197.699 157.706C197.747 157.716 197.805 157.76 197.85 157.785C197.927 157.816 198 157.864 198.077 157.895C198.125 157.904 198.183 157.949 198.228 157.974C198.305 158.005 198.379 158.053 198.456 158.084C198.501 158.109 198.562 158.137 198.607 158.163C198.681 158.21 198.758 158.241 198.832 158.289C198.892 158.317 198.937 158.342 198.998 158.37C199.072 158.418 199.149 158.449 199.223 158.497C199.284 158.525 199.329 158.55 199.39 158.578C199.464 158.626 199.541 158.657 199.615 158.704C199.675 158.733 199.72 158.758 199.778 158.802C199.852 158.85 199.929 158.881 199.987 158.925C200.048 158.953 200.09 158.995 200.151 159.023C200.225 159.07 200.302 159.102 200.359 159.146C200.42 159.174 200.462 159.215 200.523 159.244C200.597 159.291 200.658 159.319 200.732 159.367C200.793 159.395 200.851 159.439 200.912 159.468C200.985 159.515 201.046 159.543 201.12 159.591C201.178 159.635 201.239 159.663 201.297 159.707C201.355 159.752 201.432 159.783 201.49 159.827C201.548 159.872 201.608 159.9 201.682 159.947C201.74 159.992 201.817 160.023 201.875 160.067C201.933 160.112 201.994 160.14 202.052 160.184C202.11 160.228 202.183 160.276 202.244 160.304C202.302 160.348 202.363 160.377 202.421 160.421C202.479 160.465 202.553 160.513 202.614 160.541C202.672 160.585 202.733 160.613 202.79 160.658C202.848 160.702 202.922 160.749 202.98 160.794C203.038 160.838 203.112 160.885 203.17 160.93C203.228 160.974 203.285 161.018 203.362 161.049C203.42 161.094 203.494 161.141 203.568 161.188C203.626 161.233 203.684 161.277 203.745 161.305C203.819 161.353 203.876 161.397 203.95 161.444C204.008 161.489 204.066 161.533 204.127 161.561C204.201 161.609 204.272 161.672 204.346 161.719C204.387 161.76 204.448 161.789 204.49 161.83C204.564 161.877 204.635 161.941 204.709 161.988C204.767 162.032 204.812 162.058 204.869 162.102C204.956 162.168 205.043 162.235 205.117 162.282C205.162 162.307 205.188 162.345 205.233 162.371C205.364 162.462 205.48 162.551 205.609 162.658L215.048 169.845C217.552 171.753 220.171 172.288 222.324 171.357C224.474 170.442 225.97 168.091 226.52 164.878L226.505 164.959Z",
    fill: "url(#paint56_linear_2205_2999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.053 169.912L205.614 162.725C197.737 156.734 189.542 153.701 181.973 153.975C182.901 151.299 184.098 149.04 185.528 147.207C192.451 148.137 199.663 151.363 206.627 156.664L216.085 163.838C217.33 164.79 218.636 165.074 219.706 164.599C220.789 164.143 221.543 162.977 221.805 161.351L222.532 156.961C224.087 158.886 225.525 160.904 226.845 163.015L226.528 164.929C225.978 168.142 224.482 170.493 222.332 171.408C220.179 172.338 217.576 171.806 215.056 169.896L215.053 169.912Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.569 200.043C228.746 200.413 232.624 199.398 235.903 197.008C235.805 198.731 235.627 200.439 235.336 202.125C235.11 203.476 234.833 204.75 234.519 205.951C227.185 208.725 218.412 206.71 210.002 200.301L200.547 193.111C197.663 190.932 194.665 189.61 191.805 189.294C189.109 188.992 186.595 189.555 184.433 190.966C184.306 190.676 184.195 190.389 184.068 190.099C183.257 188.102 182.55 186.075 181.95 184.018C184.628 182.425 187.71 181.838 190.99 182.302C194.448 182.783 198.053 184.403 201.528 187.044L210.983 194.234C215.458 197.631 220.102 199.634 224.537 200.037L224.569 200.043Z",
    fill: "url(#paint57_linear_2205_2999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.453 171.923C236.5 181.875 238.053 192.808 236.374 202.939C234.696 213.07 230.26 219.503 224.189 221.739C218.103 223.973 210.389 222.062 202.137 215.783C193.884 209.504 187.278 200.521 183.228 190.586C179.177 180.65 177.657 169.723 179.344 159.544C181.032 149.365 185.421 143.006 191.491 140.769C197.568 138.5 205.287 140.38 213.598 146.703C221.848 152.998 228.406 161.971 232.45 171.939L232.453 171.923ZM234.532 205.97C234.845 204.769 235.123 203.495 235.349 202.145C236.972 192.385 235.478 181.927 231.6 172.39C227.706 162.849 221.422 154.177 213.385 148.072C205.348 141.967 197.868 140.134 192.043 142.302C187.611 143.957 184.117 147.899 181.982 154.01C181.319 155.907 180.78 158.027 180.402 160.344C180.334 160.696 180.283 161.051 180.231 161.406C179.877 163.943 179.718 166.501 179.739 169.077C179.765 171.62 179.992 174.153 180.367 176.697C180.738 179.174 181.297 181.621 181.994 184.044C182.595 186.1 183.298 188.143 184.112 190.125C184.223 190.412 184.35 190.701 184.477 190.991C185.428 193.214 186.506 195.379 187.695 197.482C191.447 204.042 196.428 209.909 202.378 214.436C210.413 220.556 217.851 222.348 223.669 220.213C226.563 219.142 229.059 217.115 231.058 214.131C232.527 211.924 233.71 209.214 234.561 205.992",
    fill: "url(#paint58_linear_2205_2999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.011 160.568L181.255 153.042L182.252 153.814L181.01 161.324L180.011 160.568Z",
    fill: "url(#paint59_linear_2205_2999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.562 199.194L209.017 206.384C216.385 211.995 224.054 214.661 231.032 214.092C229.049 217.08 226.55 219.122 223.643 220.174C217.825 222.31 210.387 220.518 202.353 214.397C196.402 209.87 191.437 204.007 187.669 197.443C189.25 196.469 191.084 196.074 193.045 196.318C195.169 196.576 197.404 197.552 199.546 199.191L199.562 199.194Z",
    fill: "url(#paint60_linear_2205_2999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.03 142.284C197.836 140.129 205.293 141.908 213.372 148.054C216.744 150.626 219.817 153.638 222.527 156.978L221.801 161.369C221.539 162.994 220.784 164.16 219.702 164.616C218.631 165.091 217.325 164.807 216.081 163.855L206.623 156.681C206.407 156.507 206.173 156.346 205.957 156.172C205.883 156.124 205.813 156.061 205.755 156.017C205.61 155.906 205.449 155.792 205.305 155.682C205.218 155.615 205.115 155.546 205.028 155.479C204.897 155.388 204.765 155.296 204.633 155.204C204.53 155.135 204.444 155.068 204.341 154.999C204.209 154.907 204.093 154.819 203.958 154.743C203.856 154.674 203.753 154.604 203.65 154.535C203.531 154.462 203.415 154.373 203.297 154.301C203.194 154.231 203.075 154.159 202.972 154.089C202.853 154.017 202.735 153.944 202.619 153.856C202.516 153.786 202.397 153.713 202.294 153.644C202.176 153.571 202.073 153.502 201.954 153.429C201.835 153.357 201.732 153.287 201.613 153.215C201.495 153.142 201.392 153.073 201.27 153.016C201.151 152.943 201.048 152.874 200.926 152.817C200.824 152.748 200.702 152.691 200.599 152.622C200.48 152.549 200.358 152.493 200.255 152.423C200.15 152.37 200.047 152.3 199.925 152.244C199.806 152.171 199.684 152.114 199.565 152.042C199.46 151.988 199.357 151.919 199.251 151.865C199.132 151.793 199.01 151.736 198.888 151.68C198.782 151.626 198.676 151.573 198.571 151.519C198.449 151.463 198.33 151.39 198.208 151.334C198.102 151.28 198.012 151.23 197.906 151.176C197.785 151.12 197.666 151.047 197.544 150.99C197.438 150.937 197.348 150.886 197.239 150.849C197.117 150.792 196.995 150.736 196.873 150.679C196.768 150.626 196.675 150.591 196.569 150.538C196.447 150.481 196.309 150.422 196.187 150.365C196.094 150.331 196.004 150.28 195.895 150.243C195.757 150.183 195.636 150.127 195.498 150.067C195.405 150.032 195.315 149.982 195.222 149.948C195.084 149.888 194.962 149.831 194.821 149.788C194.728 149.753 194.635 149.719 194.558 149.688C194.42 149.628 194.279 149.584 194.158 149.528C194.065 149.493 193.988 149.462 193.895 149.428C193.757 149.368 193.616 149.324 193.478 149.265C193.398 149.249 193.324 149.202 193.244 149.187C193.106 149.127 192.949 149.08 192.808 149.037C192.728 149.021 192.667 148.993 192.59 148.962C192.433 148.915 192.28 148.852 192.123 148.805C192.059 148.793 191.995 148.781 191.934 148.753C191.777 148.706 191.607 148.64 191.45 148.593C191.402 148.584 191.37 148.578 191.322 148.569C190.271 148.251 189.214 147.965 188.161 147.747C187.953 147.707 187.777 147.673 187.585 147.636C187.553 147.63 187.505 147.621 187.473 147.615C187.313 147.584 187.137 147.55 186.977 147.52C186.929 147.51 186.865 147.498 186.817 147.489C186.657 147.458 186.513 147.431 186.353 147.4C186.289 147.388 186.225 147.375 186.161 147.363C186.017 147.335 185.873 147.308 185.726 147.296C185.678 147.287 185.614 147.275 185.566 147.265C187.394 144.912 189.586 143.258 192.088 142.328L192.03 142.284Z",
    fill: "url(#paint61_linear_2205_2999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.579 187.038C198.104 184.397 194.499 182.776 191.04 182.295C187.761 181.832 184.676 182.434 182 184.012C181.304 181.588 180.764 179.129 180.374 176.664C183.513 175.176 187.047 174.743 190.753 175.404C194.667 176.105 198.702 177.991 202.595 180.961L212.051 188.151C216.468 191.504 221.07 193.2 225.316 193.035C229.329 192.876 232.897 191.055 235.632 187.781C236.002 190.871 236.106 193.961 235.935 197.014C232.659 199.389 228.794 200.422 224.601 200.049C220.184 199.633 215.522 197.644 211.047 194.247L201.592 187.057L201.579 187.038Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.244 185.804C228.856 185.137 231.828 182.704 233.815 178.837C234.643 181.784 235.248 184.77 235.617 187.778C232.878 191.069 229.329 192.877 225.301 193.033C221.055 193.197 216.452 191.501 212.035 188.148L202.58 180.958C198.686 177.988 194.651 176.102 190.737 175.401C187.031 174.74 183.497 175.174 180.358 176.662C179.964 174.131 179.756 171.585 179.729 169.042C186.933 166.607 195.43 168.669 203.596 174.882L213.051 182.071C217.166 185.184 221.446 186.486 225.247 185.788L225.244 185.804Z",
    fill: "url(#paint62_linear_2205_2999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.032 182.083L203.577 174.893C195.411 168.681 186.913 166.619 179.71 169.053C179.673 166.475 179.832 163.917 180.202 161.383C187.81 159.955 196.353 162.557 204.574 168.83L214.032 176.003C217.623 178.733 221.36 179.583 224.498 178.443C227.462 177.352 229.677 174.542 230.78 170.522C231.06 171.14 231.323 171.755 231.568 172.382C232.422 174.504 233.171 176.655 233.779 178.846C231.793 182.713 228.821 185.145 225.208 185.813C221.407 186.511 217.128 185.208 213.013 182.096L213.032 182.083Z",
    fill: "#0E0E0E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2205_2999",
    x1: 32.0415,
    y1: 99.0323,
    x2: 170.82,
    y2: 7.56229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2205_2999",
    x1: 96.0939,
    y1: 225.71,
    x2: 203.61,
    y2: 204.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2205_2999",
    x1: 58.3275,
    y1: 227.009,
    x2: 92.7304,
    y2: 203.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2205_2999",
    x1: 46.9822,
    y1: 211.979,
    x2: 78.3238,
    y2: 203.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2205_2999",
    x1: 54.6746,
    y1: 194.73,
    x2: 62.1938,
    y2: 192.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2205_2999",
    x1: 51.5925,
    y1: 180.085,
    x2: 53.9506,
    y2: 179.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2205_2999",
    x1: 51.9583,
    y1: 195.715,
    x2: 54.7933,
    y2: 195.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2205_2999",
    x1: 56.9893,
    y1: 180.128,
    x2: 60.3863,
    y2: 178.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2205_2999",
    x1: 50.4883,
    y1: 186.246,
    x2: 52.2862,
    y2: 186.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2205_2999",
    x1: 62.8243,
    y1: 200.412,
    x2: 65.6696,
    y2: 199.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2205_2999",
    x1: 56.9516,
    y1: 200.484,
    x2: 60.5038,
    y2: 198.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2205_2999",
    x1: 65.0552,
    y1: 195.442,
    x2: 66.8283,
    y2: 195.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2205_2999",
    x1: 62.8186,
    y1: 186.895,
    x2: 65.7338,
    y2: 186.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2205_2999",
    x1: 1.26108,
    y1: 119.459,
    x2: 4.6344,
    y2: 119.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2205_2999",
    x1: 2.24446,
    y1: 77.921,
    x2: 17.7256,
    y2: 67.6259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2205_2999",
    x1: 2.5694,
    y1: 180.921,
    x2: 41.1907,
    y2: 169.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2205_2999",
    x1: 97.4637,
    y1: 243.907,
    x2: 172.162,
    y2: 213.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2205_2999",
    x1: 142.559,
    y1: 240.926,
    x2: 167.01,
    y2: 235.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2205_2999",
    x1: 181.147,
    y1: 259.184,
    x2: 203.461,
    y2: 249.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2205_2999",
    x1: 189.474,
    y1: 295.105,
    x2: 220.816,
    y2: 287.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2205_2999",
    x1: 197.167,
    y1: 277.856,
    x2: 204.686,
    y2: 275.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2205_2999",
    x1: 194.085,
    y1: 263.211,
    x2: 196.443,
    y2: 262.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2205_2999",
    x1: 194.451,
    y1: 278.841,
    x2: 197.286,
    y2: 278.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2205_2999",
    x1: 199.482,
    y1: 263.254,
    x2: 202.879,
    y2: 261.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2205_2999",
    x1: 192.981,
    y1: 269.351,
    x2: 194.779,
    y2: 269.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2205_2999",
    x1: 205.317,
    y1: 283.538,
    x2: 208.162,
    y2: 282.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2205_2999",
    x1: 199.444,
    y1: 283.589,
    x2: 202.996,
    y2: 282.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2205_2999",
    x1: 207.548,
    y1: 278.568,
    x2: 209.321,
    y2: 278.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2205_2999",
    x1: 205.311,
    y1: 270.021,
    x2: 208.226,
    y2: 269.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2205_2999",
    x1: 191.345,
    y1: 285.888,
    x2: 246.78,
    y2: 260.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2205_2999",
    x1: 228.696,
    y1: 286.653,
    x2: 251.01,
    y2: 276.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2205_2999",
    x1: 237.023,
    y1: 322.575,
    x2: 268.365,
    y2: 314.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2205_2999",
    x1: 244.716,
    y1: 305.326,
    x2: 252.235,
    y2: 303.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2205_2999",
    x1: 241.612,
    y1: 290.681,
    x2: 243.97,
    y2: 289.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2205_2999",
    x1: 242,
    y1: 306.31,
    x2: 244.835,
    y2: 305.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2205_2999",
    x1: 247.009,
    y1: 290.724,
    x2: 250.406,
    y2: 289.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2205_2999",
    x1: 240.508,
    y1: 296.821,
    x2: 242.306,
    y2: 296.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2205_2999",
    x1: 252.844,
    y1: 311.007,
    x2: 255.689,
    y2: 310.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2205_2999",
    x1: 246.971,
    y1: 311.08,
    x2: 250.523,
    y2: 309.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2205_2999",
    x1: 255.075,
    y1: 306.038,
    x2: 256.848,
    y2: 305.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2205_2999",
    x1: 252.838,
    y1: 297.491,
    x2: 255.753,
    y2: 296.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2205_2999",
    x1: 238.894,
    y1: 313.191,
    x2: 294.329,
    y2: 287.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2205_2999",
    x1: 294.842,
    y1: 330.001,
    x2: 378.617,
    y2: 289.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2205_2999",
    x1: 109.997,
    y1: 341.569,
    x2: 377.883,
    y2: 247.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2205_2999",
    x1: 116.117,
    y1: 214.866,
    x2: 412.241,
    y2: 19.0517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2205_2999",
    x1: 336.497,
    y1: 332.681,
    x2: 456.079,
    y2: 307.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2205_2999",
    x1: 333.413,
    y1: 342.974,
    x2: 444.672,
    y2: 288.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2205_2999",
    x1: 337.324,
    y1: 327.135,
    x2: 356.613,
    y2: 320.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2205_2999",
    x1: 413.663,
    y1: 284.878,
    x2: 432.951,
    y2: 278.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2205_2999",
    x1: 266.899,
    y1: 122.385,
    x2: 296.116,
    y2: 103.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2205_2999",
    x1: 277.008,
    y1: 110.302,
    x2: 289.225,
    y2: 97.7207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2205_2999",
    x1: 270.919,
    y1: 113.542,
    x2: 285.34,
    y2: 96.6748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2205_2999",
    x1: 268.28,
    y1: 116.577,
    x2: 282.564,
    y2: 98.6886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2205_2999",
    x1: 267.931,
    y1: 119.175,
    x2: 281.745,
    y2: 103.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2205_2999",
    x1: 269.11,
    y1: 120.199,
    x2: 279.96,
    y2: 108.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2205_2999",
    x1: 235.872,
    y1: 203.695,
    x2: 236.944,
    y2: 203.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2205_2999",
    x1: 181.357,
    y1: 173.324,
    x2: 217.04,
    y2: 146.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2205_2999",
    x1: 182.483,
    y1: 200.838,
    x2: 218.406,
    y2: 171.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2205_2999",
    x1: 171.595,
    y1: 222.39,
    x2: 249.229,
    y2: 213.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2205_2999",
    x1: 179.634,
    y1: 161.956,
    x2: 181.299,
    y2: 162.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2205_2999",
    x1: 186.912,
    y1: 217.435,
    x2: 224.866,
    y2: 195.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2205_2999",
    x1: 185.568,
    y1: 160.673,
    x2: 220.698,
    y2: 143.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2205_2999",
    x1: 180.264,
    y1: 186.755,
    x2: 216.183,
    y2: 156.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckLeftUp);
export default __webpack_public_path__ + "static/media/truck-left-up.10ac4dfe7360b71058c8f2b285d3734c.svg";
export { ForwardRef as ReactComponent };